import { useMemo } from "react";

import type { FilterOption } from "~/shared/section";

import { useProjects } from "./api-core";

/** Сколько проектов тянуть в выпадающий список фильтра — панель не пагинируется. */
const PROJECT_OPTIONS_LIMIT = 100;

/**
 * Проекты воркспейса как опции панели фильтров. Три VM списков (ассеты,
 * генерации, чаты) повторяли этот запрос с одним и тем же лимитом и маппингом.
 */
export function useProjectFilterOptions(workspaceId: string | undefined): FilterOption[] {
    const { data } = useProjects(
        { tab: "all", workspaceId, pageSize: PROJECT_OPTIONS_LIMIT },
        { enabled: !!workspaceId },
    );
    return useMemo(() => (data?.items ?? []).map((p) => ({ value: p.id, label: p.name })), [data]);
}
